import { Seo } from '@/components/common/Seo';
import { ServiceSection } from '@/components/services/ServiceSection';
import { ServicesContactSection } from '@/components/services/ServicesContactSection';
import { ServicesHero } from '@/components/services/ServicesHero';
import { services } from '@/data/services';

export default function Services() {
  return (
    <>
      <Seo
        title="Usluge"
        description="Helmflex usluge planiranja projekata, koordinacije učesnika, uređenja digitalnih procesa i operativne podrške."
      />
      <ServicesHero />
      <div>
        {services.map((service, index) => (
          <ServiceSection key={service.id} service={service} index={index} />
        ))}
      </div>
      <ServicesContactSection />
    </>
  );
}
